import { countries } from './countries'

export const presets = {
  countries
}
